













































import { Component, Vue, Prop } from "vue-property-decorator";
import { extractConfigInfo, extractConfig } from "@/req/moneyTx";

@Component({
  components: {},
})
export default class Home extends Vue {
  @Prop({
    type: Object,
    default: () => {
      return {};
    },
  })
  public goldList;
  public columns = [
    {
      width: 200,
      title: "字段",
      key: "a",
      align: "center",
    },
    {
      width: 200,
      title: "默认状态",
      key: "b",
      align: "center",
    },
    {
      title: "规则限制",
      key: "c",
      align: "center",
    },
  ];
  public data: any = [
    {
      a: "最低提现金额",
      b: "默认为0",
      c:
        "不能输入小数点，这个字段和pc端，移动端的提现页面有关联性，该字段变更后，前端对应页面的字段也需发生变化",
    },
    {
      a: "提现手续费",
      b: "默认为0",
      c:
        "这个字段和pc端，移动端的提现页面有关联性，该字段变更后，前端对应页面的字段也需发生变化",
    },
    {
      a: "最低提现手续费",
      b: "默认为0",
      c:
        "最低为0.1，这个字段和pc端，移动端的提现页面有关联性，该字段变更后，前端对应页面的字段也需发生变化",
    },
    {
      a: "是否关闭金币充值",
      b: "默认为开启",
      c: "当状态为关闭的时候，玩家无法在盒子内使用金币充值游戏货币",
    },
    {
      a: "是否关闭金币提现",
      b: "默认为开启",
      c:
        "当状态为关闭的时候，玩家无法在盒子进入提现页面，点击提现按钮的时候，弹窗提示用户，文案：提现功能正在修复中，尽请期待",
    },
  ];
  public async save() {
    const res = await extractConfig({
      id: this.goldList.id,
      type: 1,
      min_extract_money: this.goldList.min_extract_money,
      min_extarct_ratio: this.goldList.min_extarct_ratio,
      min_extarct_charge: this.goldList.min_extarct_charge,
      close_money_pay: this.goldList.close_money_pay,
      close_money_extract: this.goldList.close_money_extract,
      explain: "",
    });
    if (res.code == 0) {
      this.$emit("getList");
      this.$Message.success(res.msg);
    }
  }
}
